import LogoIcon from "@/assets/icons/trackmate-logo.svg?react";
import { Link } from "react-router-dom";
import { Link as MuiLink } from "@mui/material";

interface IProps {
  type: "light" | "dark";
  width?: number,
  height?: number
  onClick?: () => void;
}

const Logo: React.FC<IProps> = ({ type, width, height, onClick }) => {
  return (
    <MuiLink
      component={Link}
      onClick={() => { onClick && onClick() }}
      to="/"
      sx={{
        display: "inline-block",
        width: width ? width : 204,
        height: height ? height : 38
      }}
    >
      <LogoIcon style={{
        fill: type === "light" ? "#ffffff" : "#282828",
        width: "100%",
        height: "100%",
      }} />
    </MuiLink>
  );
};

export default Logo;
